export enum EXPENSE_SORT_FIELDS {
  DATE = 'date',
  CREATED_AT = 'created_at',
  REVIEWED_AT = 'reviewed_at',
  AMOUNT = 'amount',
  STATE = 'state',
  // new fields
  TRANSACTION_DATE = 'transaction_date',
  VENDOR = 'vendor',
  CATEGORY = 'category',
  USER_ID = 'user_id',
  POSTED_DATE = 'posted_date',
  TRIP = 'trip',
  STATEMENT_DATE = 'statement_date',
  EXPENSE_TAG = 'expense_tag_bucket_id'
}

export enum TRANSACTION_SORT_FIELDS {
  DATE = 'date',
  VENDOR = 'vendor',
  AMOUNT = 'amount',
  STATE = 'state',
  TRANSACTION_DATE = 'transaction_date',
  CATEGORY = 'category',
  USER_ID = 'user_id',
  POSTED_DATE = 'posted_date',
  STATEMENT_DATE = 'statement_date',
  CREATED_AT = 'created_at'
}

export enum ALLOWED_REIMBURSABLE_COLUMNS {
  DATE = 'date',
  USER_ID = 'user_id',
  CATEGORY = 'category',
  NOTE = 'note',
  ACCOUNTING_EXPORT_STATUS = 'accounting_export_status',
  BATCH_ID = 'batch_id',
  EXPENSE_RULE_WARNINGS = 'expense_rule_warnings',
  IMAGE = 'image',
  AMOUNT = 'amount',
  RECLAIM_AMOUNT = 'reclaim_amount',
  STATE = 'state',
  MANAGER = 'manager',
  BILLABLE = 'billable',
  TRIP = 'trip',
  BUTTONS = 'buttons',
  HAS_VISIBLE_ASSURANCE_WARNINGS = 'has_visible_assurance_warnings',
  TAX_PROFILE = 'tax_profile',
  GROSS_AMOUNT = 'gross_amount',
  BASE_AMOUNT = 'base_amount',
  TAX_AMOUNT = 'tax_amount'
}

export enum ALLOWED_TRANSACTION_COLUMNS {
  VENDOR = 'vendor',
  AMOUNT = 'amount',
  NOTE = 'note',
  CARD_DETAILS = 'cardDetails',
  CATEGORY = 'category',
  USER_ID = 'user_id',
  IMAGE = 'image',
  ACCOUNTING_EXPORT_STATUS = 'accounting_export_status',
  BATCH_ID = 'batch_id',
  EXPENSE_RULE_WARNINGS = 'expense_rule_warnings',
  STATE = 'state',
  MANAGER = 'manager',
  BILLABLE = 'billable',
  SPLIT_TRANSACTION_ID = 'split_transaction_id',
  POSTED_DATE = 'posted_date',
  TRIP = 'trip',
  STATEMENT_DATE = 'statement_date',
  TRANSACTION_DATE = 'transaction_date',
  HAS_VISIBLE_ASSURANCE_WARNINGS = 'has_visible_assurance_warnings'
}

export enum ALLOWED_SORT_DIRECTION {
  ASC = 'asc',
  DESC = 'desc'
}

export enum SECTION_NAME {
  REIMBURSABLE_EXPENSE = 'reimbursable_expense',
  CARD_TRANSACTIONS = 'card_transactions'
}

export enum SCOPE {
  TEAM = 'team',
  DELEGATE = 'delegate',
  ME = 'me'
}

export enum PREFERENCE_KEYS {
  COLUMN_ORDER = 'column_order',
  COLUMN_VISIBILITY = 'column_visibility',
  SORT_FIELD = 'sort_field',
  SORT_DIRECTION = 'sort_direction',
  PAGE_SIZE = 'page_size',
  PINNED_COLUMNS = 'pinned_columns'
}

export interface ColumnInformation {
  id: string;
  type?: 'expense_tag';
  name?: string;
  visible?: boolean;
  width?: number;
}
